import { Outlet } from "react-router-dom";
import RmcProvider from "./RmcContext";

const RmcContextWrapper = () => {
  return (
    <RmcProvider>
      <Outlet />
    </RmcProvider>
  );
};

export default RmcContextWrapper;
